export const environment = {
  baseApiUrl: 'https://de-kraftheinz-dev.azurewebsites.net/',
  redirectUrl: 'https://kraft-dev-brandhealthdashboard.kantar.com/landing',
  kantarClientID: 'bdc2d0be-fb97-4f9e-9291-20f6436b61bd',
  kantarApiClientID: 'c27d11de-457f-4903-8f02-2b56b9c6d349',
  kantarAuthorityID: 'https://login.microsoftonline.com/1e355c04-e0a4-42ed-8e2d-7351591f0ef1',
  UserGuideUrl: 'https://elearning.easygenerator.com/50b37866-2ea5-47a5-b72f-12c158f7459f/#/',
  UserGuideSnapshotUrl: 'https://elearning.easygenerator.com/4168a9e6-5f42-4a18-80cd-5aeab0add565/',
  logoutURL: 'https://kraft-dev-brandhealthdashboard.kantar.com/signout-oidc',
  sessionTimeOut: '60',
  env: 'dev',
  showUploadModule: 'true',
  askMePythonUrl: '',
  dedicatedCss: '',
};
